export const autocorrectStatus = {
  on: 'Autocorrect on. The system will automatically run commands even when you mistype them.',
  off: "Autocorrect off. You'll need to confirm corrections for mistyped commands.",
} as const
